import { TimeLogFragment as TimeLog } from "@typing/Generated";

type TimeLogMonth = {
  month: number;
  timeLogs: TimeLog[];
  year: number;
};

export const timeLogsByMonth = (timeLogs: TimeLog[] | null) => {
  const months: TimeLogMonth[] = [];
  if (!timeLogs) {
    return months;
  }
  timeLogs.forEach(timeLog => {
    const parsedDate = new Date(timeLog.date);
    const month = parsedDate.getUTCMonth();
    const year = parsedDate.getUTCFullYear();
    const existingTimeLogMonth = months.find(tlMonth => tlMonth.month === month && tlMonth.year === year);
    if (existingTimeLogMonth) {
      existingTimeLogMonth.timeLogs.push(timeLog);
    } else {
      const tlMonth = {
        month,
        timeLogs: [timeLog],
        year
      };
      months.push(tlMonth);
    }
  });
  months.forEach(month => {
    month.timeLogs = month.timeLogs.sort((a, b) => {
      if (a.date === b.date) {
        return a.createdAt > b.createdAt ? 1 : -1;
      }
      return a.date > b.date ? -1 : 1;
    });
  });
  const sorted = months.sort((a, b) => {
    if (a.year === b.year) {
      return b.month - a.month;
    }
    return a.year < b.year ? 1 : -1;
  });

  return sorted;
};

export const sortByDate = (timeLogs: TimeLog[]) =>
  [...timeLogs].sort((a, b) => {
    if (!a.date || !b.date) {
      return 0;
    }

    if (a.date.getTime() === b.date.getTime()) {
      return a.createdAt > b.createdAt ? -1 : 1;
    }

    return a.date > b.date ? -1 : 1;
  });
